import { NgIf, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';

@Component({
  selector: 'app-article-card',
  imports: [
    NgIf,
    StoryblokRichTextDirective,
    StoryblokLinkDirective,
    NgOptimizedImage,
  ],
  templateUrl: './article-card.component.html',
  styleUrl: './article-card.component.scss',
})
export class ArticleCardComponent implements OnChanges {
  @Input() entry: any;

  ngOnChanges(changes: SimpleChanges): void {
    this.entry.type = this.entry.full_slug.includes('article')
      ? 'Article'
      : 'Recipe';
  }
}
